var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2313 0H1.77969C0.8 0 0.0078125 0.773438 0.0078125 1.72969V22.2656C0.0078125 23.2219 0.8 24 1.77969 24H22.2313C23.2109 24 24.0078 23.2219 24.0078 22.2703V1.72969C24.0078 0.773438 23.2109 0 22.2313 0ZM7.12812 20.4516H3.56563V8.99531H7.12812V20.4516ZM5.34688 7.43438C4.20312 7.43438 3.27969 6.51094 3.27969 5.37187C3.27969 4.23281 4.20312 3.30937 5.34688 3.30937C6.48594 3.30937 7.40937 4.23281 7.40937 5.37187C7.40937 6.50625 6.48594 7.43438 5.34688 7.43438ZM20.4594 20.4516H16.9016V14.8828C16.9016 13.5562 16.8781 11.8453 15.05 11.8453C13.1984 11.8453 12.9172 13.2937 12.9172 14.7891V20.4516H9.36406V8.99531H12.7766V10.5609H12.8234C13.2969 9.66094 14.4594 8.70938 16.1891 8.70938C19.7938 8.70938 20.4594 11.0813 20.4594 14.1656V20.4516Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0078125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkd);
export default __webpack_public_path__ + "static/media/Linkd.3aeb1099.svg";
export { ForwardRef as ReactComponent };